import React, { Component, Fragment } from 'react';
import { isEmpty, size } from "lodash";
import axios from "axios"

import { Edit, FilterListRounded, MoreVertRounded, AddCircle, CloudDownloadRounded } from '@mui/icons-material';
import { Grid, Checkbox, Menu, MenuItem, TableContainer,Typography,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableFooter,
    TablePagination,
    Button,
    IconButton,  
} from '@mui/material';

import { normalizeStr } from '../../../utils/generalFuncs';
import { matchesDesc, parseAmount, inRange } from '../../../utils/searchFilters';
import { EnhancedTableHead, EnhancedTableToolbar, headCells } from '../../../container/MUI/EnhancedTable';
import UserSpendingForm from '../../UserView/UserSpendings/UserSpendingForm'
import SpendingsUpdate from './SpendingsUpdate'
import Notif from "../../common/Notif";
import SpendingDetails from '../../Spendings/SpendingDetails';
import FilterSpendings from '../../Spendings/FilterSpendings';
import PaymentForm from '../Payments/PaymentFormAll';
import Pagination from '../../../container/MUI/Pagination';
import Currency from '../../common/Currency';
import MatchingStatus from '../../common/MatchingStatus';
import { spendingMatchingState, spendingRemaining } from '../../../utils/matchingState';
import DeleteDialog from '../../common/DeleteDialog';
import SupplierSingle from '../Suppliers/SupplierSingle';
import LabelSingle from '../Labels/LabelSingle';
import PaymentUserForm from '../Payments/PaymentUserForm';
import ProjectSingle from '../Projects/ProjectSingle';

const STATUS = {
    "WAITING_UPDATE": "À Corriger",
    "WAITING_VALIDATION": "En Attente",
    "VALIDATE": "Validé",
    "REFUSED": "Refusé"
}

const spendingHeaders = [
    { id: 'spending_pointed', numeric: false, disablePadding: false, label: 'Pointé' },
    ...headCells,
]

class SpendingsAdmin extends Component {
    state = { 
        page: 0,
        rowsPerPage: 20,

        newSpending : false,
        validateSpending : false,
        openDetails: false, 
        selectedSpending: {},
        
        openSupplier: false,
        selectedSupplier: {},
        openLabel: false,
        selectedLabel: {},
        openProject: false,
        selectedProject: {},

        filteredList: Object.values(this.props.SPENDINGS),
        spending: {},
        toDelete: {},

        checkedSpendings: [],
        singlePayment: [],

        searchLabel: {value: "", label: ""},
        searchProject: {value: "", label: ""},
        searchCategory: {value: "", label: "Toutes les catégories"},
        searchSubCategory: "",
        searchSupplier: {value: "", label: ""},
        searchFacture: "",
        searchUser: {value: "", label: ""},
        pay_status: "",
        spend_status: "",
        searchMonth: "",
        searchYear: "",
        searchDesc: "",
        amountMin: "",
        amountMax: "",

		notif:{
			openNotif: "",
			variant: "",
			message: "",
        },
        openFilters: false,
        anchorEl: null, 
        openMenu: "", 
        loading: false,
        url: "",
        spendingDemandId: "",
        spendingDemandName: "",
        spendingDemandAmount: "",
        spendingDemandAmountTTC: "",
        spendingDemandDesc: ""
    }
    componentDidMount = () => {
        window.scrollTo(0, 0);
        if(isEmpty(this.props.EQUIPEMENTS) ){
            this.props.fetchEquipements()
        }
        if(isEmpty(this.props.VEHICULES) ){
            this.props.fetchVehicules()
        }
        
        // Vérifier si le paramètre ?new=true est présent dans l'URL
        const params = new URLSearchParams(window.location.search);
        const newParam = params.get('new');
        const spendingDemandId = params.get('spending_demand_id');
        const spendingDemandNameParam = params.get('spending_demand_name');
        const spendingDemandName = spendingDemandNameParam || "";
        const spendingDemandAmount = params.get('spending_demand_amount') || "";
        const spendingDemandAmountTTC = params.get('spending_demand_amountTTC') || "";
        const spendingDemandDescParam = params.get('spending_demand_desc');
        const spendingDemandDesc = spendingDemandDescParam || "";
        const spendingId = params.get('spending_id');
        
        console.log('================== SpendingsAdmin componentDidMount ===================');
        console.log('newParam:', newParam);
        console.log('spendingDemandId:', spendingDemandId);
        console.log('spendingDemandName:', spendingDemandName);
        console.log('spendingDemandAmount:', spendingDemandAmount);
        console.log('spendingDemandAmountTTC:', spendingDemandAmountTTC);
        console.log('spendingDemandDesc:', spendingDemandDesc);
        console.log('spending_id:', spendingId);
        console.log('====================================');
        
        if (newParam === 'true') {
            this.setState({ 
                newSpending: true,
                spendingDemandId: spendingDemandId || "",
                spendingDemandName: spendingDemandName,
                spendingDemandAmount: spendingDemandAmount,
                spendingDemandAmountTTC: spendingDemandAmountTTC,
                spendingDemandDesc: spendingDemandDesc
            });
            // Nettoyer l'URL pour retirer le paramètre après ouverture de la modale
            const newUrl = window.location.pathname;
            window.history.replaceState({}, '', newUrl);
        }
        
        // Vérifier si le paramètre spending_id est présent dans l'URL
        if (spendingId) {
            this.openSpendingDetailsFromUrl(spendingId);
        }
    }
    
    componentDidUpdate = (prevProps) => {
        // Si les spendings viennent d'être chargés et qu'on attendait un spending_id de l'URL
        const params = new URLSearchParams(window.location.search);
        const spendingId = params.get('spending_id');
        
        // Ne vérifier que si on n'a pas encore ouvert la boîte de dialogue
        // et que les SPENDINGS sont maintenant disponibles alors qu'ils ne l'étaient pas avant
        if (spendingId && !this.state.openDetails) {
            const { SPENDINGS } = this.props;
            // Vérifier si les SPENDINGS sont maintenant disponibles et contiennent le spending_id recherché
            if (!isEmpty(SPENDINGS) && SPENDINGS[spendingId]) {
                // Vérifier si les SPENDINGS viennent d'être chargés ou si on n'avait pas encore essayé
                if (isEmpty(prevProps.SPENDINGS) || !prevProps.SPENDINGS[spendingId]) {
                    this.openSpendingDetailsFromUrl(spendingId);
                }
            }
        }
    }
    
    openSpendingDetailsFromUrl = (spendingId) => {
        const { SPENDINGS } = this.props;
        
        // Attendre que les spendings soient chargés
        if (!isEmpty(SPENDINGS) && SPENDINGS[spendingId]) {
            const selectedSpending = SPENDINGS[spendingId];
            this.setState({ 
                openDetails: true, 
                selectedSpending: selectedSpending 
            });
            
            // Nettoyer l'URL pour retirer le paramètre après ouverture de la modale
            const newUrl = window.location.pathname;
            window.history.replaceState({}, '', newUrl);
        }
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    // filterLabels = (spending) => {
    //     const { LABELS } = this.props;
    //     const { searchLabel } = this.state;
    //     let match = false

    //     if (searchLabel) {
    //         if (spending.spending_labels) {
    //             let searchLabels = searchLabel.split(", ") //!\ Namelist
    //             let spendingIDList = spending.spending_labels.split(", ") //!\ IDlist
    //             let spendingLabelsList = []
    //             spendingIDList.forEach( 
    //                 labelID => (
    //                     LABELS && LABELS[labelID] && spendingLabelsList.push( normalizeStr(LABELS[labelID].label_name) )
    //                 )
    //             )

    //             let nbMatch = 0 
    //             searchLabels.forEach( searching => {
    //                 let find = spendingLabelsList.filter( label => label.indexOf(normalizeStr(searching)) > -1)

    //                 if(!isEmpty(find)){
    //                     nbMatch++
    //                     spendingLabelsList.splice(spendingLabelsList.indexOf(find[0]), 1) // to prevent double match on same item
    //                 } 
    //             })
    //             match = nbMatch === size(searchLabels)

    //         } else {
    //             match = false
    //         }
    //     } else {
    //         match = true
    //     }

    //     return match
    // }
    // filterSuppliers = (spending) => {
    //     const { SUPPLIERS } = this.props;
    //     const { searchSupplier } = this.state;
    //     let match = false

    //     if (searchSupplier && SUPPLIERS) {
    //         if (spending.spending_supplier) {

    //             let searching = searchSupplier.split(", ") 
    //             let supplier = normalizeStr(SUPPLIERS[spending.spending_supplier].supplier_name)
                
    //             searching.forEach( search => {
    //                 if(supplier.indexOf(normalizeStr(search)) > -1 ) {
    //                     match = true
    //                 }
    //             })

    //         } else {
    //             match = false
    //         }
    //     } else {
    //         match = true
    //     }

    //     return match
    // }

    filterCat = (list) => {
        const { CATEGORIES } = this.props;
        const { searchCategory } = this.state;
        let newList = []

        // Pas de filtre catégorie = afficher toutes les dépenses (y compris sans catégorie)
        const noCategoryFilter = !searchCategory || !searchCategory.value || searchCategory.value === ""

        list.forEach(item => {
            if( noCategoryFilter ) {
                newList.push(item) 
            } else if( searchCategory.value === "__NO_CATEGORY__" ) {
                // Dépenses sans catégorie attribuée
                if( !item.spending_category || item.spending_category === "" ) {
                    newList.push(item) 
                }
            } else if( CATEGORIES.ALL[searchCategory.value] && CATEGORIES.ALL[searchCategory.value].includes(item.spending_category) ) {
                newList.push(item) 
            }
        })
        
        return newList
    }
    filterSubCat = (list) => {
        const { ALL, LIST } = this.props.CATEGORIES;
        const { searchSubCategory } = this.state;
        let newList = []

        list.forEach(item => {
            if( !searchSubCategory ) {
                newList.push(item) 
            } else if( item.spending_category === searchSubCategory ) {
                newList.push(item) 
            } else if ( LIST[searchSubCategory] && LIST[searchSubCategory].includes(item.spending_category)) {
                newList.push(item) 
            }
        })
        return newList
    }
    filterSubCat2 = (list) => {
        const { searchSubCategory2 } = this.state;
        let newList = []

        list.forEach(item => {
            if( !searchSubCategory2 ) {
                newList.push(item) 
            } else if( item.spending_category === searchSubCategory2) {
                newList.push(item) 
            }
        })
        return newList
    }
    filterStatus = (list) => {
        const { pay_status } = this.state;
        

        if (pay_status === "payed") {
            list = list.filter( item => item.spending_fully_paid)
        } else if (pay_status === "not_payed") {
            list = list.filter( item => !item.spending_fully_paid)
        }


        return list
    }
    filterStatusSpending = (list) => {
        const { spend_status } = this.state;
        
        if (spend_status !== "") {
            list = list.filter( item => item.spending_status === spend_status)
        }

        return list
    }
    getFilteredList = () => {
        const { SPENDINGS } = this.props;
        const { searchUser, searchFacture, searchSupplier, searchLabel, searchMonth, searchYear, searchProject, searchDesc, amountMin, amountMax } = this.state;
        // labels
        // let list = Object.values(SPENDINGS).filter(item => this.filterLabels(item))
        let list = Object.values(SPENDINGS)
        if( !isEmpty(searchLabel.value)) {
            list = list.filter( item => item.spending_labels.split(", ").includes(searchLabel.value))
        }
        if( Array.isArray(searchLabel) && !isEmpty(searchLabel) ) {
            let newList = []
            let searchLabelList = searchLabel.map(item => item.value )
            searchLabelList.forEach(label => {
                newList.push(...list.filter( item => item.spending_labels.split(", ").includes(label) ))
            })
            list = newList
        }
        if( !isEmpty(searchProject.value)) {
            list = list.filter( item => item.spending_project.split(", ").includes(searchProject.value))
        }
        if( Array.isArray(searchProject) && !isEmpty(searchProject) ) {
            let newList = []
            let searchProjectList = searchProject.map(item => item.value )
            searchProjectList.forEach(label => {
                newList.push(...list.filter( item => item.spending_project.split(", ").includes(label) ))
            })
            list = newList
        }

        // suppliers
        // list = list.filter(item => this.filterSuppliers(item))
        if( !isEmpty(searchSupplier.value)) {
            list = list.filter( item => item.spending_supplier === searchSupplier.value)
        }
        if( Array.isArray(searchSupplier) && !isEmpty(searchSupplier) ) {
            let itemList = searchSupplier.map(item => item.value )
            list = list.filter( item => itemList.includes(item.spending_supplier))
        }

        // users
        // if(!isEmpty(searchUser)){
        //     list = list.filter(item => item.spending_user === searchUser)
        // }
        if( !isEmpty(searchUser.value)) {
            list = list.filter( item => item.spending_user === searchUser.value)
        }
        if( Array.isArray(searchUser) && !isEmpty(searchUser) ) {
            let itemList = searchUser.map(item => item.value )
            list = list.filter( item => itemList.includes(item.spending_user))
        }

        if(!isEmpty(searchFacture)){
            list = list.filter(item => item.spending_id.indexOf(searchFacture.toLocaleLowerCase()) > -1)
        }
        // categories
        list = this.filterCat(list)
        // subCat
        list = this.filterSubCat(list)
        // subCat2
        list = this.filterSubCat2(list)
        // pay status
        list = this.filterStatus(list)
        // pay status spending
        list = this.filterStatusSpending(list)


        if( !isEmpty(searchMonth.value) ) {
            list = list.filter( item => new Date(item.spending_date).getMonth() == searchMonth)
        } else if( Array.isArray(searchMonth) && !isEmpty(searchMonth)) {
            let itemList = searchMonth.map(item => item.value )
            list = list.filter( item => itemList.includes(new Date(item.spending_date).getMonth()))
        } 

        if( searchYear ) {
            list = list.filter( item => new Date(item.spending_date).getFullYear() == searchYear)
        }
        if( Array.isArray(searchYear) ) {
            let itemList = searchYear.map(item => item.value )
            list = list.filter( item => itemList.includes(new Date(item.spending_date).getFullYear()))
        }

        const min = parseAmount(amountMin);
        const max = parseAmount(amountMax);
        if( searchDesc && searchDesc.trim() !== "" ) {
            list = list.filter( item => matchesDesc(item.spending_desc, searchDesc))
        }
        if( min !== null || max !== null ) {
            list = list.filter( item => inRange(item.spending_amountTTC, min, max))
        }

        return list
    }

    displayLabels = (labels) => {
        const { LABELS } = this.props;
        return labels.split(', ').map(label => LABELS && LABELS[label] && LABELS[label].label_name)
    }

    handleSelectAllClick = event => {
        if (event.target.checked) {
            let filteredList = this.getFilteredList()
            const newSelecteds = filteredList.map(item => item.spending_id);
            this.setState({
                checkedSpendings : newSelecteds
            });
          return;
        }
        this.setState({
            checkedSpendings :[]
        });  
    };
    handleSelect = (option, field) => {
        if(option){
            this.setState({                
                [field]: option,
                page: 0,
            })
        } else {
            this.setState({
                searchEmployee: {label: "", value: ""},
                page: 0,
            })

        }
    }
    
    handleClick = (event, name) => {
        const { checkedSpendings } = this.state;
        const selectedIndex = checkedSpendings.indexOf(name);
        let newSelected = [];
    
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(checkedSpendings, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(checkedSpendings.slice(1));
        } else if (selectedIndex === checkedSpendings.length - 1) {
            newSelected = newSelected.concat(checkedSpendings.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                checkedSpendings.slice(0, selectedIndex),
                checkedSpendings.slice(selectedIndex + 1),
            );
        }
    
        // console.log('====================================');
        // console.log({newSelected, name, event});
        // console.log('====================================');
        this.setState({
            checkedSpendings : newSelected
        });
    };
    getSpendingList = (list, bckg) => {
        const { rowsPerPage, page, checkedSpendings, openMenu, anchorEl } = this.state;
        const { CATEGORIES, USERS, LABELS, SUPPLIERS, PROJECTS } = this.props;

        const isSelected = name => checkedSpendings.indexOf(name) !== -1;

        return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( (item, index) => {

            let category = CATEGORIES.CHILD[item.spending_category]
            let user = isEmpty(USERS) ? {} : USERS[item.spending_user]
            let userInfo = (user.username && user.lastname) ? `${user.username[0]}.${user.lastname[0]}.` : user.email
            // let userInfo = user.username && user.lastname ? 
            // `${user.username[0].toUpperCase()}.${user.lastname[0].toUpperCase()}` : 
            // user.email

            let labels = LABELS && item.spending_labels && item.spending_labels.split(", ")
            let projects = PROJECTS && item.spending_project && item.spending_project.split(", ")
            let supplier = isEmpty(SUPPLIERS) ? {} : SUPPLIERS[item.spending_supplier]
            let isItemSelected = isSelected(item.spending_id)
            const labelId = `enhanced-table-checkbox-${index}`;

            if( item.spending_status === "WAITING_VALIDATION" ){
                bckg = "cornsilk"
            } 
            if( item.spending_status === "WAITING_UPDATE" ){
                bckg = "#f7d0d6"
            } 
            return (
                <TableRow hover key={item.spending_id} className="clickable" style={{ backgroundColor: bckg }} 
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    selected={ isItemSelected }
                >
                    <TableCell 
                        padding="checkbox"
                    >
                    {!item.spending_fully_paid && item.spending_status === "VALIDATE" &&
                        <Checkbox
                            onClick={event => this.handleClick(event, item.spending_id)}
                            disabled={item.spending_fully_paid}
                            checked={isItemSelected}
                            inputProps={{ 'aria-labelledby': labelId }}
                        />
                    }
                    </TableCell>
                    <TableCell
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                    >
                        <MatchingStatus
                            state={spendingMatchingState(item)}
                            remaining={spendingRemaining(item)}
                        />
                    </TableCell>
                    
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                    >
                        {new Date(item.spending_date).toLocaleDateString('fr-FR')}
                    </TableCell>
                    
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                        title={(user.username && user.lastname) && `${user.username} ${user.lastname}`}
                    >
                        {userInfo}
                    </TableCell>                     
                    
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                    >
                        {STATUS[item.spending_status]}
                    </TableCell>     
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                    >
                        {category && (category.category_accounting_id ? `${category.category_accounting_id} - ${category.category_name}` : category.category_name)}
                    </TableCell>                     
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                    >
                        {item.spending_desc}
                    </TableCell>   
                    <TableCell 
                        onClick={() => this.setState({openSupplier: true, selectedSupplier: supplier }) }
                        className="a-like"
                    >
                        {supplier && supplier.supplier_name}
                    </TableCell>   
                    <TableCell >
                        {labels && labels.map( (label, index) =>
                        <Fragment key={label}>
                            {index !== 0 && " | "}
                            <span
                                onClick={() => this.setState({openLabel: true, selectedLabel: LABELS[label] }) }
                                className="a-like"
                            >
                                {LABELS[label].label_name}
                            </span> 
                        </Fragment>
                        )}
                    </TableCell>   
                    <TableCell >
                        {projects && projects.map( (project, index) =>
                        <Fragment key={project}>
                            {index !== 0 && " | "}
                            <span
                                onClick={() => this.setState({openProject: true, selectedProject: PROJECTS[project] }) }
                                className="a-like"
                            >
                                {PROJECTS[project] && PROJECTS[project].project_name}
                            </span> 
                        </Fragment>
                        )}
                    </TableCell>   
                                   
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                    >
                        <Currency value={item.spending_amountTTC} />
                    </TableCell>                     
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                    >
                        {!item.spending_fully_paid &&
                            <Currency value={item.spending_rest_to_pay} />
                        }
                    </TableCell>                     
                    <TableCell>
                        {isEmpty(this.state.checkedSpendings) &&
                        <Fragment>
                            <IconButton 
                                aria-controls={`option-menu${item.spending_id}`} 
                                aria-haspopup="true"
                                onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : item.spending_id}) }>
                                <MoreVertRounded/>
                            </IconButton>

                            <Menu
                                id={`option-menu${item.spending_id}`}
                                anchorEl={anchorEl}
                                // keepMounted
                                getContentAnchorEl={null}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={ openMenu === item.spending_id}
                                onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                            >
                                {(item.spending_status === "WAITING_VALIDATION" || item.spending_status === "WAITING_UPDATE") && 
                                    <MenuItem onClick={() => this.handleOpenValidate(item) } >Compléter</MenuItem>
                                }
                                {item.spending_status === "VALIDATE" &&
                                        <MenuItem onClick={() => this.handleOpenValidate(item) } >Modifier</MenuItem>
                                }
                                {item.spending_status === "VALIDATE" && !item.spending_fully_paid &&
                                    <MenuItem 
                                        onClick={() => this.setState({ 
                                            newPayment: true, 
                                            singlePayment: [item.spending_id], 
                                            openMenu: "", 
                                            anchorEl:null}) 
                                        }
                                    >
                                        Paiement
                                    </MenuItem>
                                }
                                {item.spending_status === "VALIDATE" && !item.spending_fully_paid &&
                                    <MenuItem 
                                        onClick={() => this.setState({ 
                                            newPaymentUser: true, 
                                            singlePayment: [item.spending_id], 
                                            openMenu: "", 
                                            anchorEl:null}) 
                                        }
                                    >
                                        Paiement Collaborateur
                                    </MenuItem>
                                }
                                                  
                                {!item.spending_total_payed &&
                                    <MenuItem onClick={() => this.setState({ deleteSpending: true, toDelete: item, openMenu: "", anchorEl:null}) }>Supprimer</MenuItem>
                                }
                            </Menu>
                        </Fragment>
                        }
                    </TableCell>
                    <TableCell>{ (item?.spending_demand && item?.spending_demand !== "") &&(  <Button onClick={() => {
                         window.location.href = `/admin/spendings_demand?spending_demand_id=${item?.spending_demand}`
                    }} >Voir la demande</Button>)}</TableCell>
                </TableRow>
            )
        })
    }

    displayList = () => {
        const { SPENDINGS } = this.props;

        let tab = []
        let rows = 0
        if (!isEmpty(SPENDINGS)){
            let filteredList = this.getFilteredList()
            let filterWaiting = filteredList.filter(item => (item.spending_status === "WAITING_VALIDATION"))
            let filterUpdate = filteredList.filter(item => (item.spending_status === "WAITING_UPDATE"))
            let filterValidate = filteredList.filter(item => (item.spending_status === "VALIDATE"))
            let filterRefused = filteredList.filter(item => (item.spending_status === "REFUSED"))
            let all = [].concat(filterWaiting, filterUpdate, filterValidate, filterRefused)
            rows = size(all)
            tab.push( this.getSpendingList(all) )
            // tab.push(this.getSpendingList(filterWaiting, "cornsilk"), this.getSpendingList(filterUpdate, "#f7d0d6"), this.getSpendingList(filterValidate))
        }
        return [tab, rows]
    }

    handleOpenValidate = (spending) => {
		this.setState({
			spending,
            validateSpending: true,
            openMenu: "",
            anchorEl: null
		})
	}

    handleCompleteFromDetails = (spending) => {
        this.setState({
            openDetails: false,
            selectedSpending: {},
            validateSpending: true,
            spending: spending
        });
    }

    handleChange = (e) => {
        const { name, value} = e.target;
        if (name === "searchCategory"){
            this.setState({
                searchSubCategory: "",
                searchSubCategory2: "",
                [name]: value,
                page:0,
            })
        } else if (name === "searchSubCategory"){
            this.setState({
                searchSubCategory2: "",
                [name]: value,
                page:0,
            })
        } else {
            this.setState({
                [name]: value,
                page:0,
            })
        }
    }
    handleChangeMulti = (option, field) => {
        if (field === "searchCategory" && !isEmpty(option.value)){
            this.setState({
                searchSubCategory: "",
                searchSubCategory2: "",
                [field]: option,
                page: 0,
            })
        } else if(option){
            this.setState({                
                [field]: option,
                page: 0,
                // checkedItems :[]
            })
        } else {
            this.setState({
                [field]: field === "searchCategory" ? {label: "Toutes les catégories", value: ""} : {label: "", value: ""},
                page: 0,
                // checkedItems :[]
            })

        }
    }
    handleDelete = async () => {
        const { toDelete } = this.state;
        await this.props.deleteSpending(toDelete)
        if(this.props.STATE.spendings.error){
            this.notif(true, "error", this.props.STATE.spendings.error)
        } else {
            
            this.notif(true, "success", "Dépense supprimée")
            this.setState({
                deleteSpending: false,
                toDelete: {},
            })
        }
    }
    notif = (openNotif, variant, message) => {
        this.setState({
            notif:{
                openNotif,
                variant,
                message
            }
        })
    }

    render() {
        const { 
            page, 
            rowsPerPage, 
            newSpending, 
            validateSpending, 
            spending, 
            openDetails, 
            selectedSpending, 
            openSupplier, 
            selectedSupplier, 
            openLabel, 
            selectedLabel, 
            openProject, 
            selectedProject, 
            openFilters, 
            newPayment, 
            newPaymentUser, 
            checkedSpendings,
            singlePayment,
            deleteSpending,
            toDelete 
        } = this.state;
        const { 
            openNotif, 
            variant, 
            message 
        } = this.state.notif;

        const { SPENDINGS, SUPPLIERS, CATEGORIES, BANKS, LABELS, PAYMENTS, USERS, PROJECTS } = this.props;
        const spendingsList = this.displayList()

        console.log('spendinsList---------')
        console.log(this.displayList())
        return (
            <div >
                {(openNotif && variant && message) && 
                    <Notif
                        open={openNotif}
                        onClose={() => this.notif(false)}
                        variant={variant}
                        message={message}
                    />
                }
                {openDetails && selectedSpending && 
                    <SpendingDetails 
                        supplier={SUPPLIERS && SUPPLIERS[selectedSpending.spending_supplier]} 
                        LABELS={LABELS}
                        BANKS={BANKS}
                        PAYMENTS={PAYMENTS}
                        PROJECTS={PROJECTS}
                        category={CATEGORIES.CHILD && CATEGORIES.CHILD[selectedSpending.spending_category]} 
                        spending={selectedSpending} 
                        view="ADMIN"
                        handleClose={()=> this.setState({openDetails: false, selectedSpending: {}})}
                        fetchSpendingPayments={this.props.fetchSpendingPayments}
                        onCompleteSpending={this.handleCompleteFromDetails}
                    />
                }
                {openSupplier && selectedSupplier && 
                    <SupplierSingle 
                        open={openSupplier} 
                        supplier={selectedSupplier}
                        handleClose={()=> this.setState({openSupplier: false, selectedSupplier: {}})}
                        {...this.props} 
                    />
                }
                {openLabel && selectedLabel && 
                    <LabelSingle 
                        open={openLabel} 
                        label={selectedLabel}
                        handleClose={()=> this.setState({openLabel: false, selectedLabel: {}})}
                        {...this.props} 
                    />
                }
                {openProject && selectedProject && 
                    <ProjectSingle 
                        open={openProject} 
                        project={selectedProject}
                        handleClose={()=> this.setState({openProject: false, selectedProject: {}})}
                        {...this.props} 
                    />
                }
                {newSpending && 
                    // <SpendingsUpdate
                    //     handleClose={() => this.setState({ newSpending: false })}
                    //     notif={this.notif}
                    //     {...this.props}
                        
                    // />
                    <UserSpendingForm
                        admin
                        handleClose={() => this.setState({ newSpending: false, spendingDemandId: "", spendingDemandName: "", spendingDemandAmount: "", spendingDemandAmountTTC: "", spendingDemandDesc: "" })}
                        notif={this.notif}
                        CATEGORIES={this.props.CATEGORIES}
                        STATE={this.props.STATE}
                        newSpending={this.props.newSpending}
                        updateUserSpending={this.props.updateUserSpending}
                        createNewCategory={this.props.createNewCategory}
                        spending_demand_id={this.state.spendingDemandId}
                        spending_demand_name={this.state.spendingDemandName}
                        spending_demand_amount={this.state.spendingDemandAmount}
                        spending_demand_amountTTC={this.state.spendingDemandAmountTTC}
                        spending_demand_desc={this.state.spendingDemandDesc}
                        {...this.props}
                    />
                }
                {validateSpending && spending && 
                    <SpendingsUpdate
                        handleClose={() => this.setState({ validateSpending: false, spending: {} }) }
                        // notif={this.notif }
                        spending={this.state.spending}
                        {...this.props}
                    />
                }
                {newPayment && !isEmpty(checkedSpendings) &&
                    <PaymentForm
                        spendings={checkedSpendings}
                        handleClose={() => this.setState({ newPayment: false, checkedSpendings:[] })}
                        // notif={this.notif}
                        {...this.props}
                    />
                }
                {newPayment && !isEmpty(singlePayment) &&
                    <PaymentForm
                        spendings={singlePayment }
                        handleClose={() => this.setState({ newPayment: false, singlePayment: [] })}
                        // notif={this.notif}
                        {...this.props}
                    />
                }
                {newPaymentUser && !isEmpty(checkedSpendings) &&
                    <PaymentUserForm
                        spendings={checkedSpendings }
                        handleClose={() => this.setState({ newPaymentUser: false, checkedSpendings: [] })}
                        // notif={this.notif}
                        {...this.props}
                    />
                }
                {newPaymentUser && !isEmpty(singlePayment) &&
                    <PaymentUserForm
                        spendings={singlePayment }
                        handleClose={() => this.setState({ newPaymentUser: false, singlePayment: [] })}
                        // notif={this.notif}
                        {...this.props}
                    />
                }
                {deleteSpending && !isEmpty(toDelete) &&
                    <DeleteDialog
                        title={"la dépense"}
                        open={true}
                        close={() => this.setState({ deleteSpending: false, toDelete: {} })}
                        // notif={this.notif}
                        handleSubmit={this.handleDelete}
                        // {...this.props}
                    />
                }
                    <Typography variant="h6" id="tableTitle">
                        Liste des Dépenses
                    </Typography>
                    
                    <Grid container spacing={2} >
                    
                        <Grid item sm={6} xs={12}>
                            <Button 
                                variant="contained" 
                                color="primary"
                                onClick={() => this.setState({ openFilters: !this.state.openFilters })}
                                startIcon={<FilterListRounded />}
                            >
                                Filtres
                            </Button>
                        </Grid>
                        <Grid item sm={6} xs={12} style={{textAlign: "right"}}>
                            <Button 
                                variant="contained" 
                                color="secondary" 
                                onClick={() => this.setState({ newSpending: true })} 
                                title="Nouvelle Dépense"
                                startIcon={<AddCircle />}
                            >
                                Ajouter
                            </Button>
                            
                            <IconButton color="primary" onClick={() => this.props.openFormDownload("/extract/spendings/csv")} title="Télécharger" disabled={this.props.downloading}>
                                <CloudDownloadRounded />
                            </IconButton>
                        </Grid>
                    </Grid>

                    {openFilters && 
                        <FilterSpendings 
                            CATEGORIES={CATEGORIES}
                            USERS={USERS}
                            SUPPLIERS={SUPPLIERS}
                            LABELS={LABELS}
                            PROJECTS={PROJECTS}
                            handleClose={() => this.setState({ openFilters: false })}
                            handleChange={this.handleChange}
                            handleChangeMulti={this.handleChangeMulti}
                            handleSelect={this.handleSelect}
                            admin
                            {...this.state}
                            withSearchFilters
                        />
                    }

                    {!isEmpty(checkedSpendings) &&
                        <EnhancedTableToolbar 
                            numSelected={checkedSpendings.length} 
                            action={() => this.setState({ newPayment: true })}
                            actionCollab={() => this.setState({ newPaymentUser: true })}
                        />
                    }
                    <TableContainer>
                        <Table>
                            <EnhancedTableHead
                                // classes={classes}
                                headers={spendingHeaders}
                                numSelected={size(checkedSpendings)}
                                // onSelectAllClick={this.handleSelectAllClick}
                                rowCount={spendingsList[1]}
                            />
                       
                            <TableBody>
                                {spendingsList[0]}
                              
                            </TableBody>
                            {spendingsList[1] > 10 &&
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[20, 30]}
                                            labelRowsPerPage="Lignes par Page"
                                            colSpan={12}
                                            count={spendingsList[1]}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            SelectProps={{
                                                native: true,
                                            }}
                                            onPageChange={this.handleChangePage}
                                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                                            ActionsComponent={Pagination}
                                        />
                                    </TableRow>
                                </TableFooter>
                            }
                        </Table> 
                    </TableContainer>
               </div>
        );
    }
}

export default  SpendingsAdmin
